import {
  Styles,
  dividerClasses,
  generateClasses,
  iconButtonClasses,
  linkClasses,
  netlineAppHeaderClasses,
} from 'netline-ui';
import getAppFrameTheme from 'utils/theme';

export const appHeaderClasses = generateClasses('AppFrameAppHeader', ['root', 'main', 'logoImage'] as const);
export const appHeaderMainClassess = generateClasses(
  appHeaderClasses.main,
  ['productsVisible', 'hidden'] as const,
  true,
);

const styles: Styles = ({ theme, theme: { spacing } }) => {
  const {
    appHeader: {
      hidden,
      backgroundColor: appHeaderBackgroundColor,
      dividerColor,
      appHeaderHeight,
      dividerNextToCustomerLogoHeight,
      elementHoverBackgroundColor,
      productsMenu: {
        iconColor: productsMenuIconColor,
        backgroundColor: productsMenuBackgroundColor,
        hoverBackgroundColor: productsMenuHoverColor,
      },
      customerLogo: {
        logoHeight: customerLogoHeight,
        leftPadding: customerLogoLeftPadding,
        rightPadding: customerLogoRightPadding,
        hideCustomerLogo,
      },
    },
  } = getAppFrameTheme(theme);

  return {
    [`&.${appHeaderClasses.root} .${appHeaderClasses.main}`]: {
      ...(hidden ? { display: 'none' } : {}),
      height: appHeaderHeight,
      paddingLeft: spacing(1.5),
      paddingRight: 0,
      background: appHeaderBackgroundColor,
      transition: 'height 0.3s',
      overflow: 'hidden',
      '@supports ( -moz-appearance:none )': { paddingLeft: 12 },
      [`&.${appHeaderMainClassess.productsVisible}`]: {
        paddingLeft: 0,

        [`.${netlineAppHeaderClasses.logo}`]: {
          paddingLeft: customerLogoLeftPadding,
          paddingRight: customerLogoRightPadding,
          height: customerLogoHeight,
          display: hideCustomerLogo ? 'none' : 'inline',
        },
      },
      [`&.${appHeaderMainClassess.hidden}`]: {
        height: 0,
      },

      [`.${netlineAppHeaderClasses.logo}`]: {
        objectFit: 'contain',
        objectPosition: 'left',
        height: 28,
        width: 'auto',
      },

      [`.${netlineAppHeaderClasses.section}`]: {
        flex: 1,

        [`.${iconButtonClasses.edgeStart}`]: {
          borderRadius: 0,
          height: appHeaderHeight,
          width: 48,
          outlineColor: theme.palette.primary[800],
          outlineOffset: -2,
          marginLeft: 0,
          background: productsMenuBackgroundColor,
          color: productsMenuIconColor,

          '&:hover': {
            background: productsMenuHoverColor ?? elementHoverBackgroundColor,
          },
        },
        [`.${linkClasses.root}`]: {
          '&:focus': {
            outline: `${theme.palette.primary[800]} solid 1px}`,
            outlineOffset: 2,
          },
        },

        [`.${dividerClasses.root}`]: {
          display: hideCustomerLogo ? 'none' : '',
          background: dividerColor,
          marginLeft: 32,
          height: dividerNextToCustomerLogoHeight,
        },

        '& > h6': {
          flex: 1,
        },
      },
    },
  };
};

export default styles;
